import { render, staticRenderFns } from "./MoveCopy.vue?vue&type=template&id=232670b9"
import script from "./MoveCopy.vue?vue&type=script&lang=js"
export * from "./MoveCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports